import { Ranger } from './ranger.model';
import { RangerTypeInfoBase } from './ranger.typeinfo.base';


export class RangerTypeInfo extends RangerTypeInfoBase {
    description(item: Ranger): string {
        return '' +  item.rangerId +  ' - ' +  item.name + (item.volunteerRanger ? ' (Volunteer)' : '');
    }
}

export const RANGER_TYPE: RangerTypeInfo = new RangerTypeInfo();



